import UsersContainer from "../../container/admin/users";

const UsersView = () => {
    return <UsersContainer />;
};

export default UsersView;
